import { useEffect, useState } from "react";

const stats = [
  { label: "Indoor Court", value: 1, suffix: "" },
  { label: "Professional Coaches", value: 2, suffix: "" },
  { label: "Open Hours", value: "5:00 AM – 11:00 PM", suffix: "" },
  { label: "Coaching", value: "Mon – Sat", suffix: "" },
];

const AnimatedCounter = ({ value, suffix }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (typeof value !== "number") {
      return;
    }

    let current = 0;
    const step = Math.max(Math.floor(value / 80), 1);
    const interval = setInterval(() => {
      current += step;
      if (current >= value) {
        clearInterval(interval);
        setCount(value);
      } else {
        setCount(current);
      }
    }, 12);

    return () => clearInterval(interval);
  }, [value]);

  return (
    <span className="text-4xl font-semibold text-white sm:text-5xl">
      {typeof value === "number" ? count : value}
      {suffix}
    </span>
  );
};

const StatsSection = () => {
  return (
    <section className="mx-auto max-w-7xl px-6 py-20 sm:px-8 lg:px-12" id="stats">
      <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-4">
        {stats.map((item) => (
          <div key={item.label} className="section-card transition hover:-translate-y-1 hover:border-emerald-400/20">
            <p className="text-sm uppercase tracking-[0.32em] text-slate-400">{item.label}</p>
            <AnimatedCounter value={item.value} suffix={item.suffix} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default StatsSection;
